export function assert(condition: unknown, message?: string): asserts condition {
	if (!condition) throw new Error(message ?? "Failed assertion")
}

export const expect = <T>(value: T, message?: string): NonNullable<T> => {
	assert(value != null, message)
	return value
}
